import { createErrorWrapper } from '../utils';

export const GET_ERROR = 'NOTIFICATION.GET_ERROR';
export const DELETE_ERROR = 'NOTIFICATION.DELETE_ERROR';

export const getErr = createErrorWrapper(GET_ERROR, 'Failed to get notifications count');
export const deleteErr = createErrorWrapper(DELETE_ERROR, 'Failed to delete notification');
